import React from "react";

export default function SQLServer_TRIM() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_TRIM</h1>
      <p>This is the SQLServer_TRIM component generated from the SQL JSON.</p>
    </div>
  );
}
